import React from 'react';
import * as Images from '../../assets';
import { Box, Grid } from '@mui/material';
import {
  AppRegistration,
  ArrowRightAlt,
  Layers,
  NotificationsActive,
} from '@mui/icons-material';
import { LightBlueButton } from '../../components';
import { routesName } from '../../constants/routes-name';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Opportunities = () => {
  const { user } = useSelector(({ user }) => user);

  return (
    <div className="flex justify-center">
      <Box
        sx={{ width: { lg: '80%', md: '95%', sm: '100%', xs: '100%' } }}
        //className="lg:w-[80%] md:w-[95%] w-[100%]"
      >
        <div className="flex flex-col items-center space-y-8 py-24 px-8">
          <div className="flex flex-col gap-4">
            <div className="text-[var(--dark-blue)] font-bold tracking-[3px] uppercase">
              Business opportunities
            </div>
            <div className="divider" />
          </div>
          <div className="text-5xl font-bold">
            Save time searching for business opportunities
          </div>
          <div>
            <div className="text-center font-semibold">
              Save time searching for business opportunities
            </div>
            <div className="w-full text-center">
              Welcome to a world of business opportunities in the humanitarian
              sector, available at your fingertip.
              <br />
              We saves you time and effort, allowing you to focus on the
              opportunities that best matches you.
            </div>
          </div>

          <Grid container spacing={2} className="flex justify-center">
            <Grid item xs={12}>
              <Grid container spacing={2} className="flex justify-center">
                <Grid className="flex flex-col" item lg={3} md={4} xs={12}>
                  <div className="flex flex-col items-center gap-4">
                    <img
                      style={{ height: '50px', width: '50px' }}
                      src={Images.search}
                    />
                    <div className="text-lg font-bold text-center">
                      Access all relevant opportunities in time
                    </div>
                    <div className="text-sm text-center leading-[2]">
                      Membership ensures you have timely access to all relevant
                      business opportunities in the humaniotarian sector, so you
                      can review and respond to relevant business opportunities
                      as soon as they become available. In short, our tender
                      notice board means you always stay in the loop.
                    </div>
                  </div>
                </Grid>

                <Grid className="flex flex-col" item lg={3} md={4} xs={12}>
                  <div className="flex flex-col items-center gap-4">
                    <img
                      style={{ height: '50px', width: '50px' }}
                      src={Images.telegram}
                    />
                    <div className="text-lg font-bold text-center">
                      Our categorisation Specialists
                    </div>
                    <div className="text-sm text-center leading-[2]">
                      Our categorisation Specialists read, assess and categorise
                      every tender published, creating an accurate and easily
                      searchable database with adjacent alert service.
                    </div>
                  </div>
                </Grid>

                <Grid className="flex flex-col" item lg={3} md={4} xs={12}>
                  <div className="flex flex-col items-center gap-4">
                    <img
                      style={{ height: '50px', width: '50px' }}
                      src={Images.alerts}
                    />
                    <div className="text-lg font-bold text-center">
                      Client Alert Service
                    </div>
                    <div className="text-sm text-center leading-[2]">
                      A vast amount of undiscovered business opportunities in
                      the humanitarian sector awaits. Access our comprehensive
                      tender notice database or get Alert Service so you don’t
                      have to ever worry about missing a relevant business
                      opportunity again.
                    </div>
                  </div>
                </Grid>

                <Grid className="flex flex-col" item lg={3} md={4} xs={12}>
                  <div className="flex flex-col items-center gap-4">
                    <img
                      style={{ height: '50px', width: '50px' }}
                      src={Images.search}
                    />
                    <div className="text-lg font-bold text-center">
                      Advanced Search
                    </div>
                    <div className="text-sm text-center leading-[2]">
                      Search for business opportunities using our advanced
                      search functionality, allowing you to filter by
                      gods/services categories, geographical locations and
                      contracting organisation.
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <div className="flex justify-center">
            <Link to={routesName.pricing}>
              <LightBlueButton size="large" sx={{ fontSize: '12px' }}>
                GET STARTED <ArrowRightAlt />
              </LightBlueButton>
            </Link>
          </div>

          <div className="">
            <div className="bg-[var(--dark-blue)] mx-auto text-white space-y-4 lg:px-24 md:px-16 px-2 md:py-16 py-8 mt-12">
              <div className="text-xl font-bold text-center">
                NEVER WORRY ABOUT MISSING A TENDER OPPORTUNITY TO GROW YOUR
                BUSINESS AGAIN
              </div>
              <div className="text-center">
                Join thousands of companies who use Aid-LINK to alert them of
                business opportunities in the humanitarian sector, helping them
                to grow their business by subscriping to our tender alert
                service.
              </div>
            </div>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default Opportunities;
